import React from "react";
import "./index.css";

export const RowDivider = () => <tr className="row-divider">
  <td colSpan={8}>
    <div className="row-divider__body" />
  </td>
</tr>;
